import formGroupServer from "../../server/formGroup";

const formGroupModule = {
  namespaced: true,
  state: () => ({
    list: [],
    formGroup: {
      id: null,
      name: ""
    }
  }),
  mutations: {
    async initializeFormSubmitterForm(state, { formGroupId, name }) {
      state.formGroup.id = formGroupId;
      state.formGroup.name = name;
    }
  },
  actions: {
    async addFormGroup(context) {
      await formGroupServer.create({});
      context.dispatch("fetchFormGroups", {});
    },
    async editFormGroupSubmit(context, { submitId }) {
      await formGroupServer.update(submitId, {});
      context.dispatch("fetchFormGroups", {});
    },
    async deleteFormGroupSubmit(context, { formGroupId }) {
      await formGroupServer.delete(formGroupId);
      context.dispatch("fetchFormGroups", {});
    },
    async fetchFormGroups(context, eocId = null) {
      const forms = await formGroupServer.query(eocId);
      context.state.list = forms;
    }
  },
  getters: {
    getFormGroupById: () => async id => {
      return await formGroupServer.get(id);
    }
  }
};

export default formGroupModule;
